// extracted by mini-css-extract-plugin
module.exports = {"root":"SortableItem_root__MvNCd","dragIcon":"SortableItem_dragIcon__MgQLX","disabled":"SortableItem_disabled__2nVxy"};